const translations = {
  en: {
    dashboard: "Dashboard", students: "Students", expenses: "Expenses",
    approvals: "Approvals", admin: "Admin", balance: "Balance",
    availableFunds: "Available funds", collected: "Collected",
    totalSpent: "Total Spent", approvedExpenses: "Approved expenses",
    classSize: "Class Size", recentExpenses: "Recent Expenses",
    paymentSummary: "Payment Summary", welcomeBack: "Welcome back",
    refresh: "Refresh", paid: "Paid", unpaid: "Unpaid",
    familiesPaid: "% of families have paid", addStudent: "Add Student",
    studentName: "Student Name", parentEmail: "Parent Email",
    parentPhone: "Parent Phone", amount: "Amount",
    searchStudents: "Search by name or email...", all: "All",
    editStudent: "Edit Student", markedAsPaid: "Marked as paid",
    contributionAmount: "Contribution Amount ($)", logExpense: "Log Expense",
    description: "Description", category: "Category", date: "Date",
    submit: "Submit", approved: "Approved", pending: "Pending",
    rejected: "Rejected", allExpenses: "All expenses",
    yourExpenses: "Your submitted expenses", noExpenses: "No expenses found.",
    approveReimburse: "Approve & Reimburse", reject: "Reject",
    submittedBy: "Submitted by", pendingReimbursements: "Pending Reimbursements",
    approvalHistory: "Approval History",
    allCaughtUp: "All caught up! No pending approvals.",
    addAccount: "Add Account", newSchoolYear: "New School Year",
    accounts: "Accounts", adminPanel: "Admin Panel",
    backupRestore: "Backup & Restore", createBackup: "Create Backup Now",
    restore: "Restore", fullName: "Full Name", emailAddress: "Email Address",
    temporaryPassword: "Temporary Password", role: "Role",
    classroomMom: "Classroom Mom", resetPassword: "Reset Password",
    createAccount: "Create Account", unlock: "Unlock", newPassword: "New Password",
    signIn: "Sign In", signOut: "Sign Out", save: "Save", cancel: "Cancel",
    edit: "Edit", delete: "Delete", confirm: "Confirm", back: "Back",
    continue: "Continue", classroomFundManager: "Classroom Fund Manager",
    contactAdmin: "Contact the class admin to get your account.",
    email: "Email", password: "Password", signingIn: "Signing in...",
    studentAdded: "Student added!", studentUpdated: "Student updated!",
    studentRemoved: "Student removed.", expenseRecorded: "Expense recorded!",
    expenseSubmitted: "Expense submitted for approval!",
    expenseApproved: "Expense approved and funds deducted!",
    expenseRejected: "Expense rejected.", passwordReset: "Password reset successfully!",
    accountCreated: "Account created!", accountRemoved: "Account removed.",
    accountUnlocked: "Account unlocked!", backupCreated: "Backup created successfully!",
    databaseRestored: "Database restored successfully!",
    nameEmailRequired: "Name and email are required.",
    descriptionAmountRequired: "Description and amount required.",
    allFieldsRequired: "All fields required.",
    duplicateStudent: "A student with this name already exists.",
    invalidEmail: "Please enter a valid email address.",
    invalidCredentials: "Invalid email or password",
    tooManyAttempts: "Too many login attempts. Please try again in 15 minutes.",
    serverError: "Server error",
    newYearWarning: "This will mark ALL students as unpaid and clear all expenses. Student records will be kept. This cannot be undone.",
    newYearStep2: "Enter the new class name:", newYearStep3: "Type RESET to confirm",
    newClassName: "New Class Name",
    restoreWarning: "WARNING: This will replace ALL current data including students, expenses, and settings.",
    typeRestore: "Type RESTORE to confirm",
    min8chars: "At least 8 characters", oneUppercase: "One uppercase letter (A-Z)",
    oneNumber: "One number (0-9)", oneSpecial: "One special character",
    weak: "Weak", medium: "Medium", strong: "Strong",
    noStudentsFound: "No students found.", loading: "Loading...",
  },
  pl: {
    dashboard: "Panel Główny", students: "Uczniowie", expenses: "Wydatki",
    approvals: "Zatwierdzenia", admin: "Admin", balance: "Stan Konta",
    availableFunds: "Dostępne środki", collected: "Zebrano", totalSpent: "Wydano",
    approvedExpenses: "Zatwierdzone wydatki", classSize: "Liczba uczniów",
    recentExpenses: "Ostatnie wydatki", paymentSummary: "Podsumowanie wpłat",
    welcomeBack: "Witaj ponownie", refresh: "Odśwież", paid: "Zapłacono",
    unpaid: "Niezapłacono", familiesPaid: "% rodzin zapłaciło",
    addStudent: "Dodaj ucznia", studentName: "Imię i nazwisko",
    parentEmail: "Email rodzica", parentPhone: "Telefon rodzica", amount: "Kwota",
    searchStudents: "Szukaj po nazwisku lub emailu...", all: "Wszystkie",
    editStudent: "Edytuj ucznia", markedAsPaid: "Oznaczone jako zapłacone",
    contributionAmount: "Kwota wpłaty ($)", logExpense: "Dodaj wydatek",
    description: "Opis", category: "Kategoria", date: "Data", submit: "Zatwierdź",
    approved: "Zatwierdzone", pending: "Oczekujące", rejected: "Odrzucone",
    allExpenses: "Wszystkie wydatki", yourExpenses: "Twoje przesłane wydatki",
    noExpenses: "Nie znaleziono wydatków.", approveReimburse: "Zatwierdź i zwróć",
    reject: "Odrzuć", submittedBy: "Przesłane przez",
    pendingReimbursements: "Oczekujące zwroty", approvalHistory: "Historia zatwierdzeń",
    allCaughtUp: "Wszystko zatwierdzone! Brak oczekujących.",
    addAccount: "Dodaj konto", newSchoolYear: "Nowy rok szkolny",
    accounts: "Konta", adminPanel: "Panel admina",
    backupRestore: "Kopia i przywracanie", createBackup: "Utwórz kopię teraz",
    restore: "Przywróć", fullName: "Imię i nazwisko", emailAddress: "Adres email",
    temporaryPassword: "Tymczasowe hasło", role: "Rola",
    classroomMom: "Mama klasowa", resetPassword: "Zresetuj hasło",
    createAccount: "Utwórz konto", unlock: "Odblokuj", newPassword: "Nowe hasło",
    signIn: "Zaloguj się", signOut: "Wyloguj się", save: "Zapisz", cancel: "Anuluj",
    edit: "Edytuj", delete: "Usuń", confirm: "Potwierdź", back: "Wstecz",
    continue: "Kontynuuj", classroomFundManager: "Zarządzanie funduszem klasy",
    contactAdmin: "Skontaktuj się z administratorem aby uzyskać konto.",
    email: "Email", password: "Hasło", signingIn: "Logowanie...",
    studentAdded: "Uczeń dodany!", studentUpdated: "Uczeń zaktualizowany!",
    studentRemoved: "Uczeń usunięty.", expenseRecorded: "Wydatek zapisany!",
    expenseSubmitted: "Wydatek wysłany do zatwierdzenia!",
    expenseApproved: "Wydatek zatwierdzony i środki odjęte!",
    expenseRejected: "Wydatek odrzucony.", passwordReset: "Hasło zresetowane pomyślnie!",
    accountCreated: "Konto utworzone!", accountRemoved: "Konto usunięte.",
    accountUnlocked: "Konto odblokowane!", backupCreated: "Kopia zapasowa utworzona!",
    databaseRestored: "Baza danych przywrócona!",
    nameEmailRequired: "Imię i email są wymagane.",
    descriptionAmountRequired: "Opis i kwota są wymagane.",
    allFieldsRequired: "Wszystkie pola są wymagane.",
    duplicateStudent: "Uczeń o tym nazwisku już istnieje.",
    invalidEmail: "Proszę podać prawidłowy adres email.",
    invalidCredentials: "Nieprawidłowy email lub hasło",
    tooManyAttempts: "Zbyt wiele prób logowania. Spróbuj ponownie za 15 minut.",
    serverError: "Błąd serwera",
    newYearWarning: "Wszyscy uczniowie zostaną oznaczeni jako niezapłaceni i wszystkie wydatki zostaną usunięte. Dane uczniów zostaną zachowane. Tej operacji nie można cofnąć.",
    newYearStep2: "Podaj nazwę nowej klasy:", newYearStep3: "Wpisz RESET aby potwierdzić",
    newClassName: "Nazwa nowej klasy",
    restoreWarning: "UWAGA: Spowoduje to zastąpienie WSZYSTKICH bieżących danych.",
    typeRestore: "Wpisz RESTORE aby potwierdzić",
    min8chars: "Co najmniej 8 znaków", oneUppercase: "Jedna wielka litera (A-Z)",
    oneNumber: "Jedna cyfra (0-9)", oneSpecial: "Jeden znak specjalny",
    weak: "Słabe", medium: "Średnie", strong: "Silne",
    noStudentsFound: "Nie znaleziono uczniów.", loading: "Ładowanie...",
  }
};
export default translations;
